"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const LabeledGroupWidget_1 = tslib_1.__importDefault(require("../widget/LabeledGroupWidget"));
const fmko_ts_common_1 = require("fmko-ts-common");
const Div_1 = tslib_1.__importDefault(require("../elements/Div"));
class WCAGRadioGroup extends LabeledGroupWidget_1.default {
    constructor(args) {
        super({
            ...args,
            groupChildElements: []
        });
    }
    setValue(newValue, fireEvents = false) {
        for (const radioButton of this.groupChildElements) {
            radioButton.setChecked(false);
        }
        const matchingRadio = this.groupChildElements.find(radioButton => fmko_ts_common_1.CompareUtil.deepEquals(radioButton.getCheckedValue(), newValue));
        if (!!matchingRadio) {
            matchingRadio.setChecked(true);
            super.setValue(newValue, fireEvents);
        }
        else {
            super.setValue(undefined, fireEvents);
        }
    }
    getValue() {
        return this.value;
    }
    clearValue(fireEvents = false) {
        super.clearValue(fireEvents);
        for (const radio of this.groupChildElements) {
            radio.clearValue(fireEvents);
        }
    }
    addRadioButton(radioButton) {
        radioButton.setName(this.nameAttribute);
        radioButton.addValueChangeHandler(() => {
            const checkedRadio = this.groupChildElements.find(radio => radio.isChecked());
            if (checkedRadio && checkedRadio !== radioButton) {
                return;
            }
            this.setValue(radioButton.getCheckedValue(), true);
        });
        this.groupChildElements.push(radioButton);
        this.groupElement.appendChild(radioButton.element);
    }
    /**
     * Removes all radio buttons from the group
     */
    removeRadioButtons() {
        this.groupChildElements = [];
        while (this.groupElement.lastElementChild) {
            this.groupElement.removeChild(this.groupElement.lastElementChild);
        }
        this.clearValue();
    }
    decorateLabeledGroupElement(args) {
        const { radioButtons = [], nameAttribute = fmko_ts_common_1.GlobalCounter.next() } = args;
        this.nameAttribute = nameAttribute;
        this.element = document.createElement("div");
        this.element.classList.add("radio-group");
        this.groupChildElements = [];
        let selectedCount = 0;
        radioButtons.forEach(radioButton => {
            this.addRadioButton(radioButton);
            if (radioButton.getFieldElement().checked) {
                this.setValue(radioButton.getValue());
                selectedCount++;
            }
        });
        const labelWrapper = new Div_1.default();
        labelWrapper.add(this.labelElement);
        if (this.labelImage) {
            labelWrapper.add(this.labelImage);
        }
        this.add(labelWrapper);
        this.add(this.groupElement);
        if (selectedCount > 1) {
            throw "More than one RadioButton are selected";
        }
    }
}
exports.default = WCAGRadioGroup;
//# sourceMappingURL=WCAGRadioGroup.js.map